import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import store from './data/store';
import SiteHeaderSearchMobile from './ui/main';

export const initMobileSearch = () => {
    const $root = document.getElementById('header-search-m-placeholder');
    if (!$root) return;

    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <SiteHeaderSearchMobile />
            </Provider>
        </React.StrictMode>,
        $root
    );
};